<script setup lang="ts">
import { computed, toRef } from 'vue'
import { useDatetimeString } from '#shared/lib/datetime/use-datetime-string'

const { unreadCount, unreadUpdatedAt } = defineProps<{ unreadCount: number; unreadUpdatedAt: Date }>()

const formattedMessageCount = computed(() => {
  if (unreadCount === 0) return '1 new message'
  return `${unreadCount} new messages`
})
const datetimeString = useDatetimeString(toRef(() => unreadUpdatedAt))
</script>

<template>
  <button :class="$style.root">{{ formattedMessageCount }} since {{ datetimeString }}</button>
</template>

<style lang="scss" module>
@use '#mixins/button' as button;

.root {
  @include button.primary;

  & {
    height: 26px;
    font-size: 14px;
  }
}
</style>
